import { graphql } from '@/api/gql'

export const getAuthProvider = graphql(`
  query getAuthProvider($email: String!, $sourceUri: String) {
    data: getAuthProvider(email: $email, sourceUri: $sourceUri) {
      providerUrl
      error {
        code
        message
      }
    }
  }
`)
